/****************************************************
 * Module Name:  addColorModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddColorModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newcolor: this.props.editOperation ? this.props.sourceData.name : "",
      newcolorfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",

      showError: false,

      validateColorPresentSpinner: false,
      showValidationMessage: false,
      colorAvailable: true,

      colorValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newcolor,
      fullname: this.state.newcolorfullname,
      description: this.state.newdescription,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateColorPresent = (colorEntered) => {
    if (!colorEntered || colorEntered.trim() === "") return;

    this.setState({
      validateColorPresentSpinner: true,
    });

    ColorProxy.CheckColorAvailable(colorEntered, (response) => {
      //if we got response that means color is present at backend
      if (response) {
        //ColorName already present
        this.setState({
          validateColorPresentSpinner: false,
          showValidationMessage: true,
          colorAvailable: false,
        });
      } else {
        //ColorName not available, so can be used
        this.setState({
          validateColorPresentSpinner: false,
          showValidationMessage: true,
          colorAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newcolorfullname.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.colorAvailable ||
        this.state.newcolorfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add color validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Color" : "Add New Color"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Color Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Color <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newcolor}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Color (required)"
                          placeholder="Enter Color"
                          value={this.state.newcolor}
                          autoFocus
                          onBlur={(e) =>
                            this.validateColorPresent(this.state.newcolor)
                          }
                          onChange={(e) =>
                            this.setState({
                              newcolor: e.target.value,
                              showValidationMessage: false,
                              colorValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Color Cannot be Empty",
                            })
                          }
                          helperText={this.state.colorValidationError}
                          error={this.state.colorValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateColorPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.colorAvailable ? (
                        <font color="green">Color available</font>
                      ) : (
                        <font color="red">Color not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Color Fullname</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        size="small"
                        label="Color Fullname"
                        placeholder="Enter Color Fullname"
                        value={this.state.newcolorfullname}
                        onChange={(e) =>
                          this.setState({
                            newcolorfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Color Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
